import {MediaTypeEnum} from '@shared/enums/media-type.enum';
import {ViewType} from '@shared/enums/view-type.enum';
import {IFileUpload} from '@interfaces/media';

export class GetAdvertiserMedia {
  static readonly type = '[Advertiser Media] get media';

  constructor() {
  }
}

export class AdvertiserSearchMedia {
  static readonly type = '[Advertiser media] search media';

  constructor(public search: string) {
  }
}

export class AdvertiserSetMediaPage {
  static readonly type = '[Advertiser media] set page';

  constructor(public page: number) {
  }
}

export class AdvertiserGetMediaByType {
  static readonly type = '[Advertiser media] get media by type';

  constructor(public type: MediaTypeEnum) {
  }
}

export class AdvertiserSetMediaView {
  static readonly type = '[Advertiser media] set media view';

  constructor(public type: ViewType) {
  }
}

export class AdvertiserDeleteMedia {
  static readonly type = '[Advertiser media] delete media';

  constructor(public ids: number[]) {
  }
}

export class AdvertiserCleanMediaStore {
  static readonly type = '[Advertiser media] clean store';
}

export class AdvertiserAddMedia {
  static readonly type = '[Advertiser media] add media';

  constructor(public file: IFileUpload) {
  }
}

export class AdvertiserSortMedia {
  static readonly type = '[Advertiser media] sort media';

  constructor(public payload: {
    sort: string
  }) {
  }
}
